/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import * as httpUtils from '@bingads-webui/http-util';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import * as recommendationRepository from '@bingads-webui-campaign/recommendation-repository';
import * as gmcToMMCGridDeps from '@bingads-webui-campaign-react/gmc-to-mmc-mapping-grid-shared';

import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import editAdGroupPage from '@bingads-webui-campaign-legacy/adgroup-settings/view/index';
import editCampaignPage from '@bingads-webui-campaign-legacy/campaign-settings/view/index';
import editShoppingCampaignPage from '@bingads-webui-campaign-legacy/shopping-campaign/view/campaign-creation/update';
import editSmartShoppingCampaignPage from '@bingads-webui-campaign-legacy/shopping-campaign/view/campaign-creation/smart-shopping-campaign-settings';
import { AudienceAdgroupSettingsWizard } from '@bingads-webui-campaign-legacy/audience-campaign/loader';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import pageContext from '@bingads-webui-static-legacy/page-context';
import * as criterionLoader from '@bingads-webui-campaign-legacy/base-targets/util/criterionLoader';
import LocationMap from '@bingads-webui-campaign-legacy/location-targets/view/locationMap';
import * as locationTargetConverter from '@bingads-webui-campaign-legacy/location-targets/util/locationTargetConverter';
import CampaignCacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import sessionStorage from '@bingads-webui-component-legacy/storage/sessionStorage';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';


export function getDeps(contexts) {
  const {
    serverContext: {
      CurrentAccount: {
        AdvertiserCustomerID,
        Id,
      },
      Token,
      ServicesEndpoints: { CampaignAPI },
    },
  } = contexts;

  return {
    deps: {
      isNewUI: true,
      AudienceAdgroupSettingsWizard,
      logger,
      criterionLoader,
      editAdGroupPage,
      editCampaignPage,
      editShoppingCampaignPage,
      editSmartShoppingCampaignPage,
      i18nErrors,
      pageContext,
      i18n: window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/targeting-settings'),
      i18nGlobal: window.globalLegacyI18n.get('module/extension/requirejs/i18n!global'),
      legacyGlobalI18n: window.globalLegacyI18n.get('component/i18n/loader!legacy/global'),
      LocationMap,
      locationTargetConverter,
      odataOptions: {
        host: CampaignAPI,
        oDataToken: Token,
        // SessionId: _.result(config.get('Omniture'), 'SessionId'),
        // [shasharm]Maybe not needed, add back if window.required
        params: {
          customer_id: AdvertiserCustomerID,
          account_id: Id,
        },
      },
      httpUtils,
      AlertHelper,
      recommendationRepository,
      CampaignCacheManager,
      constants,
      sessionStorage,
      decimal,
      gmcToMMCGridDeps,
    },
  };
}
